
import ResourceList from "./list";


if (document.body.getAttribute("data-current-path") === "settings/resources") {
    const action = document.body.getAttribute("data-current-action")
    if (action === "index") {
        new ResourceList();
    }
}